var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-wrap"},[_vm._m(0),_vm._m(1),_c('div',{staticStyle:{"background":"#fff"}},[_c('JumpForm')],1),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-banner sign-banner"},[_c('p',{staticClass:"common-banner__chinese"},[_vm._v("电子签章")]),_c('p',{staticClass:"common-banner__english"},[_vm._v("Electronic seal")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-content"},[_c('div',{staticClass:"title"})])
}]

export { render, staticRenderFns }